export const CustomCompanies = {
    Frewie: "frewie",
    MyAc: "myac"
}

export const CustomCompanyList = [
    CustomCompanies.Frewie,
    CustomCompanies.MyAc
]